import api from "./Api";

class ConversaoService {
  ConverterPlanilha(payload) {
    return api
      .post("/v1/Conversao/ConverterPlanilha", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new ConversaoService();
